import httpClient from './httpClient'

class PagesApi {
  static async getAuth(urlArray) {
    try {
      return await httpClient.post('/auth/page', urlArray)
    } catch (e) {
      throw e
    }
  }
  static async getPagePermission(url) {
    try {
      const ret = await httpClient.post('/auth/page', [url])
      const permission = ret.data.item[0]
      return permission
    } catch (e) {
      throw e
    }
  }
}

export default PagesApi
